import { Param } from 'src/app/shared/models/domain/param';
import { CommonEnums } from '../../common.enums';

export class ParamsUtil {
    private static instance: ParamsUtil;

    static getInstance() {
        if (!ParamsUtil.instance) {
            ParamsUtil.instance = new ParamsUtil();
        }

        return ParamsUtil.instance;
    }

    /**
    * ParamsUtil is a singleton class, so use ParamsUtil.getInstance() method instead of creating new ParamsUtil().
    */
    private constructor() {

    }

    getParamNm(param: Param, obj_Cd: string, reusableFlag: string = 'N', obj_Nm: string, fldr_Cd: string): string {
        let prefix: string = this.getParamPrefix(obj_Cd, param.paramTyp, reusableFlag);
        let paramNm: string = '';

        if (obj_Cd == 'RSTJ') {
            paramNm = prefix + obj_Nm + "." + param.nm;
        } else if (obj_Cd == 'FLDR' &&
            reusableFlag == CommonEnums.reusableFlag.YES) {
            paramNm = prefix + fldr_Cd + "_" + param.nm;
            param.change_Ind = 'C';
        } else {
            paramNm = prefix + param.nm;
            param.change_Ind = 'C';
        }

        return paramNm.toUpperCase();
    }

    getParamPrefix(obj_Cd: string, paramTyp: string, reusableFlag: string = 'N'): string {
        if (obj_Cd == 'DXMP') {
            return paramTyp == 'S' ? "$SP_" : "$MP_";
        }

        if (obj_Cd == 'DXFLOW') {
            return paramTyp == 'S' ? "$FS_" : "$FL_";
        }

        if (obj_Cd == 'RSTJ') {
            return "$RT_";
        }

        if (obj_Cd == 'FLDR') {
            return reusableFlag == 'N' ? "$PP_" : "$GP_";
        }

        if (obj_Cd == 'PP') {
            return reusableFlag == 'N' ? "$PP_" : "$GP_";
        }

        return '';
    }

    getNm(paramTyp: string, nm: string = ''): string {
        return nm != '' ? nm : paramTyp == 'S' ? 'SQL_PARAM_NAME_1' : 'PARAM_NAME_1';
    }

    copy(params: Array<Param>): Array<Param> {
        let paramsTmp: Array<Param> = new Array<Param>();

        for (let i: number = 0; i < params.length; i++) {
            let param: Param = params[i] as Param;
            paramsTmp.push(param.copy())
        }

        return paramsTmp;
    }

    copyFrom(params: Array<Param>, paramsTmp: Array<Param>): void {
        let paramsMap: Map<string, Param> = new Map();

        for (let i: number = 0; i < params.length; i++) {
            let param: Param = params[i] as Param;
            let key = param.param_Id + '-' + param.obj_Id;
            paramsMap.set(key, param);
        }

        params.splice(0, params.length);

        for (let i: number = 0; i < paramsTmp.length; i++) {
            let paramTmp: Param = paramsTmp[i] as Param;
            let key = paramTmp.param_Id + '-' + paramTmp.obj_Id;
            let param: Param = paramsMap.get(key);
            if (param) {
                param.copyFrom(paramTmp);
            } else {
                param = Param.parse(paramTmp);
            }

            params.push(param);
        }
    }

    compare(params: Array<Param>, paramsTmp: Array<Param>): string {
        if (params.length != paramsTmp.length)
            return 'Params length mismatch.';

        for (let i: number = 0; i < params.length; i++) {
            let param: Param = params[i] as Param;
            let paramTmp: Param = paramsTmp[i] as Param;

            let diffString: string = param.compare(paramTmp);
            if (diffString != '') {
                return diffString;
            }
        }

        return '';
    }

    getChangedParams(params: Array<Param>, paramsTmp: Array<Param>): Array<Param> {
        let changedParams: Array<Param> = new Array<Param>();
        let paramsCopyMap: Map<string, Param> = new Map();
        for (let i = 0; i < paramsTmp.length; i++) {
            paramsCopyMap.set(paramsTmp[i].param_Id  + '' + paramsTmp[i].obj_Id, paramsTmp[i]);

        }
        for (let i: number = 0; i < params.length; i++) {
            let param = params[i];
            let paramCopy = paramsCopyMap.get(param.param_Id + '' + param.obj_Id);
            if (!paramCopy) {
                changedParams.push(param);
                continue;
            }

            let diffString: string = param.compare(paramCopy);
            if (diffString != '') {
                param.change_Ind = 'Y';
                changedParams.push(param);
                continue;
            }

        }

        return changedParams;
    }

    toString(params: Array<Param>): string {
        let str: string = '';

        str += 'Params length: ' + params.length + ' ';

        for (let i: number = 0; i < params.length; i++) {
            let paramTmp: Param = params[i] as Param;
            str += paramTmp.toString();
        }

        return str;
    }
}